// extracted by mini-css-extract-plugin
export default {"wrap":"EmptyState_wrap__aHKqR","icon":"EmptyState_icon__74n9a","title":"EmptyState_title__qpA3H","body":"EmptyState_body__9BBts","button":"EmptyState_button__lb0Mi"};